import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../DataDomain';
import {
    IChannelEntity,
    IChannelInfoResponse,
    IChannelsResponse,
    IGetChannelInfoParams,
    IGetChannelScheduleParams,
    IGetChannelScheduleResponse,
    IGetChannelsMiniEPGParams,
    IGetChannelsParams,
    IMiniEPGResponse,
} from '../../entity';
import { IGetChannelMiniEPGUseCase } from '../../core/usecases/channel/GetChannelMiniEpgUseCase';
import { IGetChannelsUseCase } from '../../core/usecases/channel/GetChannelsUseCase';
import { IGetAllChannelsUseCase } from '../../core/usecases/channel/GetAllChannelsUseCase';
import { IGetChannelInfoUseCase } from '../../core/usecases/channel/GetChannelInfoUseCase';
import { IGetChannelScheduleUseCase } from '../../core/usecases/channel/GetChannelScheduleUseCase';
import { IGetChannelsArrisSTBUseCase } from '../../core/usecases/channel/GetChannelsArrisSTBUseCase';
import { IGetChannelScheduleByDataSourceUseCase } from '../../core/usecases/channel/GetChannelScheduleByDataSourceUseCase';

export interface IChannelService {
    getChannelsMiniEPG(params: IGetChannelsMiniEPGParams): Promise<string[]>;
    getChannels(params: IGetChannelsParams): Promise<IChannelEntity[]>;
    getAllChannels(params: IGetChannelsParams): Promise<IChannelEntity[]>;
    getChannelInfo(params: IGetChannelInfoParams): Promise<IChannelInfoResponse>;
    getChannelsArrisSTB(params: IGetChannelsParams): Promise<IChannelEntity[]>;
    getChannelSchedule(params: IGetChannelScheduleParams): Promise<IGetChannelScheduleResponse>;
    getChannelScheduleByDataSource(
        datasource: string,
        params: IGetChannelScheduleParams
    ): Promise<IGetChannelScheduleResponse>;
}

export class ChannelService implements IChannelService {
    // Lazy getters for dependencies to avoid circular dependencies
    private get getChannelMiniEPGUseCase(): IGetChannelMiniEPGUseCase {
        return container.resolve<IGetChannelMiniEPGUseCase>(DI.USECASES.IGetChannelMiniEPGUseCase);
    }

    private get getChannelsUseCase(): IGetChannelsUseCase {
        return container.resolve<IGetChannelsUseCase>(DI.USECASES.IGetChannelsUseCase);
    }

    private get getAllChannelsUseCase(): IGetAllChannelsUseCase {
        return container.resolve<IGetAllChannelsUseCase>(DI.USECASES.IGetAllChannelsUseCase);
    }

    private get getChannelInfoUseCase(): IGetChannelInfoUseCase {
        return container.resolve<IGetChannelInfoUseCase>(DI.USECASES.IGetChannelInfoUseCase);
    }

    private get getChannelScheduleUseCase(): IGetChannelScheduleUseCase {
        return container.resolve<IGetChannelScheduleUseCase>(DI.USECASES.IGetChannelScheduleUseCase);
    }

    private get getChannelScheduleByDataSourceUseCase(): IGetChannelScheduleByDataSourceUseCase {
        return container.resolve<IGetChannelScheduleByDataSourceUseCase>(
            DI.USECASES.IGetChannelScheduleByDataSourceUseCase
        );
    }

    private get getChannelsArrisSTBUseCase(): IGetChannelsArrisSTBUseCase {
        return container.resolve<IGetChannelsArrisSTBUseCase>(DI.USECASES.IGetChannelsArrisSTBUseCase);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async getChannelsMiniEPG(params: IGetChannelsMiniEPGParams): Promise<string[]> {
        return await this.getChannelMiniEPGUseCase.execute(params);
    }

    async getChannels(params: IGetChannelsParams): Promise<IChannelEntity[]> {
        return await this.getChannelsUseCase.execute(params);
    }

    async getAllChannels(params: IGetChannelsParams): Promise<IChannelEntity[]> {
        return await this.getAllChannelsUseCase.execute(params);
    }

    async getChannelInfo(params: IGetChannelInfoParams): Promise<IChannelInfoResponse> {
        return await this.getChannelInfoUseCase.execute(params);
    }

    async getChannelsArrisSTB(params: IGetChannelsParams): Promise<IChannelEntity[]> {
        return await this.getChannelsArrisSTBUseCase.execute(params);
    }

    async getChannelSchedule(params: IGetChannelScheduleParams): Promise<IGetChannelScheduleResponse> {
        return await this.getChannelScheduleUseCase.execute(params);
    }
    async getChannelScheduleByDataSource(
        datasource: string,
        params: IGetChannelScheduleParams
    ): Promise<IGetChannelScheduleResponse> {
        return await this.getChannelScheduleByDataSourceUseCase.execute(datasource, params);
    }
}
